export { default } from "./DatoCmsFaqBlock";
